import * as React from 'react'
import { DynamicCx } from 'common/types/index'
import { styling } from 'common/utils'
const s = require(`./loading_${process.env.PROJECT_NAME}.scss`)

interface OwnProps {
  cx?: DynamicCx
  isFull?: boolean
  style?: React.CSSProperties
}

const Loader: React.SFC<OwnProps> = ({ cx, isFull }) => {
  return (
    <div className={cx('loader', { full: isFull }, '@_ncp_comment_loading_bar')} key="loader">
      <span className={cx('ico_loading')}>
        <span className={cx('@blind')}>로딩 중</span>
      </span>
    </div>
  )
}

const styled = styling(s)(Loader)
export default styled
